namespace RioERP.Products {
    export enum SharingType {
        Percentage = 1,
        FixAmount = 2
    }
    Serenity.Decorators.registerEnumType(SharingType, 'RioERP.Products.SharingType');
}
